<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Sidebar -->
    <Sidebar />

    <!-- Main Content -->
    <div
      class="transition-all duration-500 min-h-screen"
      :class="[isSidebarCollapsed ? 'ml-20' : 'ml-64']"
    >
      <!-- Page Content -->
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Sidebar from "@/components/layout/SidebarView.vue";

const isUserMenuOpen = ref(false);
const isSidebarCollapsed = ref(false);

// Watch for sidebar collapse state from localStorage
onMounted(() => {
  const checkSidebarState = () => {
    const collapsed = localStorage.getItem("sidebarCollapsed");
    isSidebarCollapsed.value = collapsed === "true";
  };

  checkSidebarState();

  // Listen for sidebar state changes
  window.addEventListener("storage", checkSidebarState);

  // Custom event for same-tab updates
  window.addEventListener("sidebar-state-change", checkSidebarState);

  // Click outside directive
  const handleClickOutside = (event) => {
    if (isUserMenuOpen.value) {
      const userMenu = document.querySelector(".user-menu");
      if (userMenu && !userMenu.contains(event.target)) {
        isUserMenuOpen.value = false;
      }
    }
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    window.removeEventListener("storage", checkSidebarState);
    window.removeEventListener("sidebar-state-change", checkSidebarState);
    document.removeEventListener("click", handleClickOutside);
  };
});
</script>

<style></style>
